import { EventName } from '../offline-events';

export interface BadDateRange {
  start: string; // ISO Date (YYYY-MM-DD)
  end: string; /// ISO Date (YYYY-MM-DD)
  eventName: EventName;
}

export const exampleBadDateRange: BadDateRange = {
  start: '2019-01-01',
  end: '2019-12-31',
  eventName: EventName.Purchase,
};
